import { http } from "src/newApi";

export interface ArticleCategory {
	departmentId: number;
	department: string;
	tagId: number | null;
	tag: string | null;
}

/** Artykuł z /v2 (MySQL): cała treść jako jeden HTML, sekcje = h2. */
export interface Article {
	id: number;
	title: string;
	/** HTML. */
	source: string | null;
	/** HTML całego artykułu (sekcje = h2). */
	content: string | null;
	createdAt: string;
	updatedAt: string;
	categories: ArticleCategory[];
}

/** Backend: api-service/routes/v2/articles.ts (paid). */
export function getArticle(id: number) {
	return http.get<Article>(`/v2/articles/${id}`).then(({ data }) => data);
}
